module.exports = __webpack_public_path__ + "media/images/haircut/card-mobile-ab14a02f2bc7bc4cff68edfc851ea8fd.jpg";